import { render } from "./BookLibrary.vue?vue&type=template&id=18f65c04&scoped=true"
import script from "./BookLibrary.vue?vue&type=script&lang=js"
export * from "./BookLibrary.vue?vue&type=script&lang=js"

import "./BookLibrary.vue?vue&type=style&index=0&id=18f65c04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f65c04"]])

export default __exports__